import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { withTheme } from 'styled-components';
import { hasSelectedEnterpriseMewsMerchant } from '../../../../selectors/views/selectedEnterprisePaymentConfiguration';

export const inject = compose(
    withTheme,
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    connect(
        createStructuredSelector({
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            isMerchant: hasSelectedEnterpriseMewsMerchant,
        })
    )
);
